import { render, staticRenderFns } from "./EventCardList.vue?vue&type=template&id=1d64086c"
import script from "./EventCardList.vue?vue&type=script&lang=js"
export * from "./EventCardList.vue?vue&type=script&lang=js"
import style0 from "./EventCardList.vue?vue&type=style&index=0&id=1d64086c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports